import * as Request from '../Request';

const Organization = {
  // 新增部门
  addDepartment: (data) => {
    return Request.post('/sys/dept/save', data);
  },
  // 删除部门
  deleteDepartment: (data) => {
    return Request.delBody('/sys/dept/delete', data);
  },
  // 修改部门
  updateDepartment: (data) => {
    return Request.put('/sys/dept/update', data);
  },
  // 部门详情
  departmentDetail: (data) => {
    return Request.get('/sys/dept/info', data);
  },
  // 上传头像
  uploadAvatar: (data) => {
    return Request.post('/sys/user/fileUpload', data);
  },
  // 全部人员选项（id+姓名，消息接收人候选用）
  userOptions: (data) => {
    return Request.get('/sys/user/options', data);
  },
  // 根据部门Id和员工姓名，模糊分页查询员工信息
  personnelList: (data) => {
    return Request.post('/sys/user/list', data);
  },
  // 系统部门人员
  sysUserList: (data) => {
    return Request.post('/sys/user/appUsage/list', data);
  },
  // 添加人员
  addPersonnel: (data) => {
    return Request.post('/sys/user/save', data);
  },
  // 删除人员
  deletePersonnel: (data) => {
    return Request.delBody('/sys/user/delete', data);
  },
  // 人员详情
  personnelDetail: (data) => {
    return Request.get('/sys/user/info', data);
  },
  // 修改人员
  updatePersonnel: (data) => {
    return Request.put('/sys/user/update', data);
  },
  // 重置密码
  resetPassword: (id) => {
    return Request.put(`/sys/user/resetPwd?userId=${id}`);
  },
  // 租户公司人员系统列表
  systemList: (data) => {
    return Request.get('/sys/user/application/list', data);
  }
}
export default Organization
